import { ref, watch } from 'vue';
import agentsApi from 'dashboard/api/agents';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAbortableRequest } from 'dashboard/composables/useAbortableRequest';

// CRM ownership belongs to the Account, not the last selected conversation inbox.
export function useCrmAgents() {
  const { accountId } = useAccount();
  const { run, isPending } = useAbortableRequest();
  const agentsList = ref([]);
  const hasError = ref(false);

  const load = async () => {
    agentsList.value = [];
    hasError.value = false;
    try {
      await run(async signal => {
        const { data } = await agentsApi.get();
        if (!signal.aborted) agentsList.value = data;
      });
    } catch {
      hasError.value = true;
    }
  };

  watch(accountId, load, { immediate: true, flush: 'sync' });
  return { agentsList, hasError, isPending, load };
}
